/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IError } from '../../../../../base/api';
import { SetFieldParams } from '../../../../../base/interfaces/params';
import { PasswordRecoveryStep } from '../../enums';

export interface Fields {
    phone: string;
    password: string;
    smsCode?: string;
}

export interface PasswordRecoveryState {
    step: PasswordRecoveryStep;
    fields: Fields;
    errors: IError | null;
    shouldScrollToError: boolean;
    passwordResetToken: string;
}

const fieldsInitialState = {
    phone: '',
    password: '',
};

const initialState: PasswordRecoveryState = {
    step: PasswordRecoveryStep.VerificationMethod,
    fields: fieldsInitialState,
    errors: null,
    shouldScrollToError: false,
    passwordResetToken: '',
};

export const passwordRecoverySlice = createSlice({
    name: 'worker-app__password-recovery',
    initialState,
    reducers: {
        setStep: (state, action: PayloadAction<PasswordRecoveryStep>) => {
            state.step = action.payload;
        },
        setPasswordResetToken: (state, action: PayloadAction<string>) => {
            state.passwordResetToken = action.payload;
        },
        clearData: (state) => {
            state.step = PasswordRecoveryStep.VerificationMethod;
            state.fields = fieldsInitialState;
            state.errors = null;
            state.shouldScrollToError = false;
            state.passwordResetToken = '';
        },
        setField: (state, action: PayloadAction<SetFieldParams>) => {
            state.fields = {
                ...state.fields,
                [action.payload.id]: action.payload.value,
            };
            if (state.errors === null) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.payload.errorGroupName || action.payload.id]: removedError, ...errors } = state.errors;
            state.errors = errors;
        },
        setErrors: (state, action: PayloadAction<IError>) => {
            if (state.errors) {
                state.errors = {
                    ...state.errors,
                    ...action.payload,
                };
            } else {
                state.errors = action.payload;
            }
        },
        setShouldScrollToError: (state, action: PayloadAction<boolean>) => {
            state.shouldScrollToError = action.payload;
        },
        resendConfirmation: {
            reducer: () => {},
            prepare: (recaptchaToken: string | null) => ({ payload: recaptchaToken }),
        },
        submitRecoverPassword: () => {},
        submitSetNewPassword: () => {},
        submitChangeConfirmationValue: {
            reducer: () => {},
            prepare: (newValue: string, recaptchaToken: string | null, callback: () => void) => ({
                payload: { newValue, recaptchaToken, callback },
            }),
        },
    },
});

export const passwordRecoveryActions = passwordRecoverySlice.actions;
export const passwordRecoveryReducer = passwordRecoverySlice.reducer;
